<template>
  <!-- Modal for selecting a municipality -->
  <div
    class="modal fade"
    id="municipalityModal"
    tabindex="-1"
    aria-labelledby="municipalityModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="municipalityModalLabel">
            Indlæs kommunale valgresultater
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Luk"
          ></button>
        </div>
        <div class="modal-body">
          <small>Data fra kommunalvalget 2021.</small>
          <select class="form-control" @change="onChange($event)">
            <option value="">-- vælg kommune --</option>
            <option
              v-for="item in sortedMunicipalities"
              :value="item.municipalityCode"
              v-bind:key="item.municipalityCode"
              >{{ item.municipalityName }}</option
            >
          </select>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-success"
            data-bs-dismiss="modal"
            @click="onClick"
          >
            Vælg kommune
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'MunicipalityDropdown',
  emits: ['municipalityChanged'],
  computed: {
    sortedMunicipalities: function() {
      return _.orderBy(this.municipalities, 'municipalityName', 'asc');
    },
  },
  methods: {
    onChange: function(event) {
      this.selectedMunicipalityCode = event.target.value;
    },
    onClick: function() {
      this.$emit('municipalityChanged', this.selectedMunicipalityCode);
    },
  },
  data: function() {
    return {
      selectedMunicipalityCode: '',
      municipalities: [
        {
          municipalityCode: '0101',
          municipalityName: 'Københavns Kommune',
        },
        {
          municipalityCode: '0147',
          municipalityName: 'Frederiksberg Kommune',
        },
        {
          municipalityCode: '0151',
          municipalityName: 'Ballerup Kommune',
        },
        {
          municipalityCode: '0153',
          municipalityName: 'Brøndby Kommune',
        },
        {
          municipalityCode: '0155',
          municipalityName: 'Dragør Kommune',
        },
        {
          municipalityCode: '0157',
          municipalityName: 'Gentofte Kommune',
        },
        {
          municipalityCode: '0159',
          municipalityName: 'Gladsaxe Kommune',
        },
        {
          municipalityCode: '0161',
          municipalityName: 'Glostrup Kommune',
        },
        {
          municipalityCode: '0163',
          municipalityName: 'Herlev Kommune',
        },
        {
          municipalityCode: '0165',
          municipalityName: 'Albertslund Kommune',
        },
        {
          municipalityCode: '0167',
          municipalityName: 'Hvidovre Kommune',
        },
        {
          municipalityCode: '0169',
          municipalityName: 'Høje-Taastrup Kommune',
        },
        {
          municipalityCode: '0173',
          municipalityName: 'Lyngby-Taarbæk Kommune',
        },
        {
          municipalityCode: '0175',
          municipalityName: 'Rødovre Kommune',
        },
        {
          municipalityCode: '0183',
          municipalityName: 'Ishøj Kommune',
        },
        {
          municipalityCode: '0185',
          municipalityName: 'Tårnby Kommune',
        },
        {
          municipalityCode: '0187',
          municipalityName: 'Vallensbæk Kommune',
        },
        {
          municipalityCode: '0190',
          municipalityName: 'Furesø Kommune',
        },
        {
          municipalityCode: '0201',
          municipalityName: 'Allerød Kommune',
        },
        {
          municipalityCode: '0210',
          municipalityName: 'Fredensborg Kommune',
        },
        {
          municipalityCode: '0217',
          municipalityName: 'Helsingør Kommune',
        },
        {
          municipalityCode: '0219',
          municipalityName: 'Hillerød Kommune',
        },
        {
          municipalityCode: '0223',
          municipalityName: 'Hørsholm Kommune',
        },
        {
          municipalityCode: '0230',
          municipalityName: 'Rudersdal Kommune',
        },
        {
          municipalityCode: '0240',
          municipalityName: 'Egedal Kommune',
        },
        {
          municipalityCode: '0250',
          municipalityName: 'Frederikssund Kommune',
        },
        {
          municipalityCode: '0253',
          municipalityName: 'Greve Kommune',
        },
        {
          municipalityCode: '0259',
          municipalityName: 'Køge Kommune',
        },
        {
          municipalityCode: '0260',
          municipalityName: 'Halsnæs Kommune',
        },
        {
          municipalityCode: '0265',
          municipalityName: 'Roskilde Kommune',
        },
        {
          municipalityCode: '0269',
          municipalityName: 'Solrød Kommune',
        },
        {
          municipalityCode: '0270',
          municipalityName: 'Gribskov Kommune',
        },
        {
          municipalityCode: '0306',
          municipalityName: 'Odsherred Kommune',
        },
        {
          municipalityCode: '0316',
          municipalityName: 'Holbæk Kommune',
        },
        {
          municipalityCode: '0320',
          municipalityName: 'Faxe Kommune',
        },
        {
          municipalityCode: '0326',
          municipalityName: 'Kalundborg Kommune',
        },
        {
          municipalityCode: '0329',
          municipalityName: 'Ringsted Kommune',
        },
        {
          municipalityCode: '0330',
          municipalityName: 'Slagelse Kommune',
        },
        {
          municipalityCode: '0336',
          municipalityName: 'Stevns Kommune',
        },
        {
          municipalityCode: '0340',
          municipalityName: 'Sorø Kommune',
        },
        {
          municipalityCode: '0350',
          municipalityName: 'Lejre Kommune',
        },
        {
          municipalityCode: '0360',
          municipalityName: 'Lolland Kommune',
        },
        {
          municipalityCode: '0370',
          municipalityName: 'Næstved Kommune',
        },
        {
          municipalityCode: '0376',
          municipalityName: 'Guldborgsund Kommune',
        },
        {
          municipalityCode: '0390',
          municipalityName: 'Vordingborg Kommune',
        },
        {
          municipalityCode: '0400',
          municipalityName: 'Bornholm Kommune',
        },
        {
          municipalityCode: '0410',
          municipalityName: 'Middelfart Kommune',
        },
        {
          municipalityCode: '0420',
          municipalityName: 'Assens Kommune',
        },
        {
          municipalityCode: '0430',
          municipalityName: 'Faaborg-Midtfyn Kommune',
        },
        {
          municipalityCode: '0440',
          municipalityName: 'Kerteminde Kommune',
        },
        {
          municipalityCode: '0450',
          municipalityName: 'Nyborg Kommune',
        },
        {
          municipalityCode: '0461',
          municipalityName: 'Odense Kommune',
        },
        {
          municipalityCode: '0479',
          municipalityName: 'Svendborg Kommune',
        },
        {
          municipalityCode: '0480',
          municipalityName: 'Nordfyns Kommune',
        },
        {
          municipalityCode: '0482',
          municipalityName: 'Langeland Kommune',
        },
        {
          municipalityCode: '0492',
          municipalityName: 'Ærø Kommune',
        },
        {
          municipalityCode: '0510',
          municipalityName: 'Haderslev Kommune',
        },
        {
          municipalityCode: '0530',
          municipalityName: 'Billund Kommune',
        },
        {
          municipalityCode: '0540',
          municipalityName: 'Sønderborg Kommune',
        },
        {
          municipalityCode: '0550',
          municipalityName: 'Tønder Kommune',
        },
        {
          municipalityCode: '0561',
          municipalityName: 'Esbjerg Kommune',
        },
        {
          municipalityCode: '0563',
          municipalityName: 'Fanø Kommune',
        },
        {
          municipalityCode: '0573',
          municipalityName: 'Varde Kommune',
        },
        {
          municipalityCode: '0575',
          municipalityName: 'Vejen Kommune',
        },
        {
          municipalityCode: '0580',
          municipalityName: 'Aabenraa Kommune',
        },
        {
          municipalityCode: '0607',
          municipalityName: 'Fredericia Kommune',
        },
        {
          municipalityCode: '0615',
          municipalityName: 'Horsens Kommune',
        },
        {
          municipalityCode: '0621',
          municipalityName: 'Kolding Kommune',
        },
        {
          municipalityCode: '0630',
          municipalityName: 'Vejle Kommune',
        },
        {
          municipalityCode: '0657',
          municipalityName: 'Herning Kommune',
        },
        {
          municipalityCode: '0661',
          municipalityName: 'Holstebro Kommune',
        },
        {
          municipalityCode: '0665',
          municipalityName: 'Lemvig Kommune',
        },
        {
          municipalityCode: '0671',
          municipalityName: 'Struer Kommune',
        },
        {
          municipalityCode: '0706',
          municipalityName: 'Syddjurs Kommune',
        },
        {
          municipalityCode: '0707',
          municipalityName: 'Norddjurs Kommune',
        },
        {
          municipalityCode: '0710',
          municipalityName: 'Favrskov Kommune',
        },
        {
          municipalityCode: '0727',
          municipalityName: 'Odder Kommune',
        },
        {
          municipalityCode: '0730',
          municipalityName: 'Randers Kommune',
        },
        {
          municipalityCode: '0740',
          municipalityName: 'Silkeborg Kommune',
        },
        {
          municipalityCode: '0741',
          municipalityName: 'Samsø Kommune',
        },
        {
          municipalityCode: '0746',
          municipalityName: 'Skanderborg Kommune',
        },
        {
          municipalityCode: '0751',
          municipalityName: 'Aarhus Kommune',
        },
        {
          municipalityCode: '0756',
          municipalityName: 'Ikast-Brande',
        },
        {
          municipalityCode: '0760',
          municipalityName: 'Ringkøbing-Skjern Kommune',
        },
        {
          municipalityCode: '0766',
          municipalityName: 'Hedensted Kommune',
        },
        {
          municipalityCode: '0773',
          municipalityName: 'Morsø Kommune',
        },
        {
          municipalityCode: '0779',
          municipalityName: 'Skive Kommune',
        },
        {
          municipalityCode: '0787',
          municipalityName: 'Thisted Kommune',
        },
        {
          municipalityCode: '0791',
          municipalityName: 'Viborg Kommune',
        },
        {
          municipalityCode: '0810',
          municipalityName: 'Brønderslev Kommune',
        },
        {
          municipalityCode: '0813',
          municipalityName: 'Frederikshavn Kommune',
        },
        {
          municipalityCode: '0820',
          municipalityName: 'Vesthimmerlands Kommune',
        },
        {
          municipalityCode: '0825',
          municipalityName: 'Læsø Kommune',
        },
        {
          municipalityCode: '0840',
          municipalityName: 'Rebild Kommune',
        },
        {
          municipalityCode: '0846',
          municipalityName: 'Mariagerfjord Kommune',
        },
        {
          municipalityCode: '0849',
          municipalityName: 'Jammerbugt Kommune',
        },
        {
          municipalityCode: '0851',
          municipalityName: 'Aalborg Kommune',
        },
        {
          municipalityCode: '0860',
          municipalityName: 'Hjørring Kommune',
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
